// extracted by mini-css-extract-plugin
export var cancelButton = "_4r-5";
export var content = "_4r-3";
export var createButton = "_4r-6";
export var createOrderColumn = "_4r-4";
export var drawerContainer = "_4r-0";
export var footer = "_4r-2";
export var header = "_4r-1";